import { sdk as imageSdk } from '@wix/image-kit';
import { HTTP_PREFIX } from '../consts';
import { getImageFilenameFromUrl } from './get-image-filename-from-url';
import { isSVGfile } from './images-file-type-detection';
import { removePrefix } from './string-utils';
const ALL_PATH = '/media/';
const SVG_PATH = '/shapes/';
const MEDIA_PREFIX = 'media/';
const WIX_STATICS_PREFIX = 'https://static.wixstatic.com';
export const resolveImageUrl = (favicon, targetWidth, targetHeight) => {
  if (!isWixImage(favicon)) {
    return favicon;
  }
  const imageFilename = getImageFilenameFromUrl(favicon);
  const url = imageSdk.getScaleToFillImageURL(imageFilename, 0, 0, targetWidth, targetHeight);
  if (isSVGfile(imageFilename)) {
    return url.replace(ALL_PATH, SVG_PATH);
  }
  return url;
};
export const originalImageUrl = imageUrl => {
  imageUrl = removePrefix(imageUrl, MEDIA_PREFIX);
  return isSVGfile(imageUrl) ? `https://static.wixstatic.com/shapes/${imageUrl}` : `https://static.wixstatic.com/media/${imageUrl}`;
};
const isWixImage = imageUri => imageUri.startsWith(WIX_STATICS_PREFIX) || !imageUri.startsWith(HTTP_PREFIX);
//# sourceMappingURL=resolve-image-url.js.map